import { Helmet } from "react-helmet";
import React from "react";
import Navbar from "../Components/LandingNav";
import Services from "../Components/Services";
// import Banner from "../Components/Banner";
import Lottery from "../Components/Lottery";
import LotteryDisplay from "../Components/LotteryDisplay";
import Plans from "../Components/Plans";
import ContactInfo from "../Components/ContactInfo.jsx";
import ContactInfoForm from "../Components/ContactInfoForm";
import Footer from "../Components/Footer";
import AppDownload from "../Components/AppDownload";
import "../styles/main.css";
import Testimonials from "../Components/Testimonials";

export default function Landing() {
	return (
		<div style={{ background: "white", color: "black", overflowX: "hidden", width: "100%" }}>
			<Helmet>
				<title>BeyondLottery</title>
				<meta name='description' content='Beyond Lottery app' />
				<link rel='icon' href='/favicon.png' />
			</Helmet>

			<Navbar />

			<main>
				<Services />
				<Lottery />
				<LotteryDisplay />
				<Plans />
				<Testimonials />
				<ContactInfo />
				<ContactInfoForm />
				<AppDownload />
				<Footer />
			</main>
		</div>
	);
}
